import { render, staticRenderFns } from "./ParticipantsListTest.vue?vue&type=template&id=3c43a57c&scoped=true&"
import script from "./ParticipantsListTest.vue?vue&type=script&lang=js&"
export * from "./ParticipantsListTest.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsListTest.vue?vue&type=style&index=0&id=3c43a57c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c43a57c",
  null
  
)

export default component.exports